import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5.091 3.18253V2.54616C5.091 1.84298 5.66054 1.27344 6.36373 1.27344H7.63645C8.33963 1.27344 8.90918 1.84298 8.90918 2.54616V3.18253H11.4546C11.8059 3.18253 12.091 3.46762 12.091 3.81889C12.091 4.17017 11.8059 4.45526 11.4546 4.45526V10.8189C11.4546 11.8733 10.6 12.728 9.54554 12.728H4.45463C3.40018 12.728 2.54554 11.8733 2.54554 10.8189V4.45526C2.19427 4.45526 1.90918 4.17017 1.90918 3.81889C1.90918 3.46762 2.19427 3.18253 2.54554 3.18253H5.091ZM6.36373 3.18253H7.63645V2.54616H6.36373V3.18253ZM3.81827 10.8189V4.45526H10.1819V10.8189C10.1819 11.1702 9.89682 11.4553 9.54554 11.4553H4.45463C4.10336 11.4553 3.81827 11.1702 3.81827 10.8189Z",
  fill: "#FEFEFE"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };